import { useEffect, useState } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { errMsg } from "@/components/attendance/ui";

export default function LibraryGaps({ onAdd, refreshKey, onChanged }) {
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/admin/projection/gaps").then((r) => setG(r.data)).catch(() => {}); }, [refreshKey]);
  if (!g) return null;
  const restore = async () => {
    if (!window.confirm("Re-add any CAC hymns from the original files that are missing from the library? Existing and edited hymns are never changed.")) return;
    try { const r = await api.post("/admin/projection/seed-cac"); toast.success(`${r.data.created} hymns restored`); onChanged?.(); } catch (e) { toast.error(errMsg(e)); }
  };
  const total = g.missing.en.length + g.missing.yo.length + g.unlinked.length;
  return (
    <div className="luxury-card rounded-xl p-4 space-y-2" data-testid="library-gaps">
      <div className="flex flex-wrap items-center gap-3">
        <AlertTriangle size={16} className={total ? "text-amber-300" : "text-emerald-300"} />
        <span className="text-sm text-white">{total ? "Library gaps to review" : `Library complete — CAC 1 to ${g.highest} in English and Yoruba`}</span>
        <div className="flex-1" />
        <button onClick={restore} className="text-[11px] inline-flex items-center gap-1 text-neutral-400 hover:text-[#D4AF37]" data-testid="gaps-restore"><RotateCcw size={12} /> Restore missing from original files</button>
      </div>
      {["en", "yo"].map((l) => g.missing[l].length > 0 && (
        <div key={l} className="flex flex-wrap items-center gap-2 text-xs" data-testid={`gaps-missing-${l}`}>
          <span className="text-neutral-400 w-36">Missing {l === "en" ? "English" : "Yoruba"}:</span>
          {g.missing[l].map((n) => (
            <button key={n} onClick={() => onAdd({ language: l, cac_number: n })} data-testid={`gap-add-${l}-${n}`} title="Add this hymn"
              className="px-2 py-1 rounded border border-amber-300/40 text-amber-200 hover:bg-amber-300/10">+ {n}</button>
          ))}
        </div>
      ))}
      {g.unlinked.length > 0 && <div className="text-xs text-neutral-400" data-testid="gaps-unlinked">Same number but not linked EN↔YO: {g.unlinked.join(", ")}</div>}
    </div>
  );
}
